<template>
  <div class="panel-body border-bottom">

    <app-question-editor class="mt-2"
                          :data-show-label="false"
                          :data-interaction="interactionStored"
                          :question="true"
                          :maxLength="60"
                          @change="(evt) => $emit('update', evt)"
                          @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {paginaPosAutenticacao: evt}})"></app-question-editor>

    <open-field-editor :data-interaction="interactionStored"></open-field-editor>

    <app-option-editor @change="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {nome: evt}})"
                       @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {paginaPosAutenticacao: evt}})"
                       :data-title="$t('message.campaigns.message.button')"
                       :data-interaction="interactionStored"
                       :data-option="interactionStored.opcoes[0]"
                       :data-max-length="maxLength"
                       :data-counter="maxLength" >
    </app-option-editor>
  </div>
</template>

<script>
import AppQuestionEditor from '../QuestionEditor'
import AppOptionEditor from '../OptionEditor'
import panelBody from '../../mixins/panel-body'
import OpenFieldEditor from './editor/OpenFieldEditor'

export default {
  components: {
      AppQuestionEditor,
      AppOptionEditor,
      OpenFieldEditor
  },

  data() {
    return {
        maxLength: 24
    }
  },

  mixins: [panelBody]
}
</script>

<style lang="scss" scoped>
@import "../../mixins/panel-body";
</style>

